import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
export default defineComponent({
  name: 'ProductLabels',
  props: {
    labels: {
      type: Array,
      required: true
    }
  },
  setup: function setup(props) {
    var sortedLabels = computed(function () {
      var labels = _toConsumableArray(props.labels);
      var sortByScoreOrAlphabetically = function sortByScoreOrAlphabetically(a, b) {
        var _a$fields, _b$fields;
        if (((_a$fields = a.fields) === null || _a$fields === void 0 ? void 0 : _a$fields.score) == (b === null || b === void 0 ? void 0 : (_b$fields = b.fields) === null || _b$fields === void 0 ? void 0 : _b$fields.score)) {
          var _a$fields2, _a$fields2$title, _b$fields2, _b$fields2$title;
          var nameA = a === null || a === void 0 ? void 0 : (_a$fields2 = a.fields) === null || _a$fields2 === void 0 ? void 0 : (_a$fields2$title = _a$fields2.title) === null || _a$fields2$title === void 0 ? void 0 : _a$fields2$title.toUpperCase();
          var nameB = b === null || b === void 0 ? void 0 : (_b$fields2 = b.fields) === null || _b$fields2 === void 0 ? void 0 : (_b$fields2$title = _b$fields2.title) === null || _b$fields2$title === void 0 ? void 0 : _b$fields2$title.toUpperCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        } else {
          var _b$fields3, _a$fields3;
          return (b === null || b === void 0 ? void 0 : (_b$fields3 = b.fields) === null || _b$fields3 === void 0 ? void 0 : _b$fields3.score) - (a === null || a === void 0 ? void 0 : (_a$fields3 = a.fields) === null || _a$fields3 === void 0 ? void 0 : _a$fields3.score);
        }
      };
      return checkIfThereIsAFields(labels.sort(sortByScoreOrAlphabetically));
    });
    function checkIfThereIsAFields(array) {
      var result = array.filter(function (item) {
        return 'fields' in item;
      });
      return result;
    }
    return {
      sortedLabels: sortedLabels
    };
  }
});